import { Routes, Route } from "react-router-dom";
import { useCallback, useEffect, useState, lazy, Suspense } from "react";
import { Context } from "./Context";
import {
  GET_ALL_COUNTRY,
  GET_ALL_STATE_BY_COUNTY_ID,
  GET_ALL_STATE_BY_NAME,
  USER_PROFILE,
  fetchData,
} from "./Service";
import Loading from "./Loading";
import useRandomToasts from "./ToastNotification";
import { parseCookies } from "nookies";
import { destroyCookie,setCookie } from "nookies";

// Lazy load components for better performance
const Home = lazy(() => import("../modules/home/Home"));
const AboutUs = lazy(() => import("../modules/about-us/AboutUs"));
const Privacy = lazy(() => import("../modules/privacy/Privacy"));
const CountryLayout = lazy(() => import("./layout/CountryLayout"));
const Disclaimer = lazy(() => import("../modules/disclaimer/Disclaimer"));
const Autos = lazy(() => import("../modules/autos/Autos"));
const Carpool = lazy(() => import("../modules/carpool/Carpool"));
const Advertise = lazy(() => import("../modules/advertise/Advertise"));
const BusinessListing = lazy(() => import("../modules/business-listing/BusinessListing"));
const ContactUs = lazy(() => import("../modules/contact-us/ContactUs"));
const FreeAds = lazy(() => import("../modules/free-ads/FreeAds"));
const Movie = lazy(() => import("../modules/movies/Movie"));
const RealEstate = lazy(() => import("../modules/real-estate/RealEstate"));
const StudentTalk = lazy(() => import("../modules/student-talks/StudentTalk"));
const TermsCondition = lazy(() => import("../modules/terms-condition/TermsCondition"));
const Forum = lazy(() => import("../modules/forum/Forum"));
const ForumDetails = lazy(() => import("../modules/forum/ForumDetails"));
const NrisTalk = lazy(() => import("../modules/nris-talk/NrisTalk"));
const NrisTalkDetails = lazy(() => import("../modules/nris-talk/NrisTalkDetails"));
const StudentTalkDetails = lazy(() => import("../modules/student-talks/StudentTalkDetails"));
const MovieReviews = lazy(() => import("../modules/movies/MovieReviews"));
const MovieReviewsDetails = lazy(() => import("../modules/movies/MovieReviewsDetails"));
const Event = lazy(() => import("../modules/event/Event"));
const EventDetails = lazy(() => import("../modules/event/EventDetails"));
const Traning = lazy(() => import("../modules/traning/Traning"));
const TraningDetails = lazy(() => import("../modules/traning/TraningDetails"));
const Blog = lazy(() => import("../modules/blog/Blog"));
const BlogDetails = lazy(() => import("../modules/blog/BlogDetails"));
const AdsWrapper = lazy(() => import("./layout/AdsWrapper"));
const RealEstateDetails = lazy(() => import("../modules/real-estate/RealEstateDetails"));
const CarpoolDetails = lazy(() => import("../modules/carpool/CarpoolDetails"));
const AutosDetails = lazy(() => import("../modules/autos/AutosDetails"));
const FreeAdsDetails = lazy(() => import("../modules/free-ads/FreeAdsDetails"));
const News = lazy(() => import("../modules/news/News"));
const NewsDetails = lazy(() => import("../modules/news/NewsDetails"));
const BusinessDetails = lazy(() => import("../modules/business-listing/BusinessDetails"));
const SearchResults = lazy(() => import("../modules/search-results/SearchResults"));
const MovieAll = lazy(() => import("../modules/movies/MovieAll"));
const CreateCarpool = lazy(() => import("../modules/carpool/CreateCarpool"));
const Classified = lazy(() => import("../modules/free-ads/Classified"));
const DesiPage = lazy(() => import("../modules/desi-page/DesiPage"));
const DesiPageDetails = lazy(() => import("../modules/desi-page/DesiPageDetails"));
const MyProfile = lazy(() => import("../modules/profile/MyProfile"));
const NotFound = lazy(() => import("./NotFound"));
const ChangeForgotPassword = lazy(() => import("../modules/change-forgot-password/ChangeForgotPassword"));
const CreateAds = lazy(() => import("../modules/create-ads/CreateAds"));
const VerifyEmail = lazy(() => import("../modules/verify-email/VerifyEmail"));

const Routing = () => {
  const [context, setContext] = useState({ listView: true });
  console.log("aaa",context)
  const nrisCookies = parseCookies();
  const SESSION_DURATION = 45 * 60 * 1000 ;

  // Get current hostname for dynamic domain handling
  const host = window?.location?.hostname;
  const isLocalhost = host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0';
  const isStageServer = host && (host.includes('nris-stage') || host.includes('stage') || host.includes('staging') || host.includes('dev') || host.includes('test'));
  const isLiveServer = host && (host === 'www.nris.com' || host === 'nris.com');
  
  // Determine cookie domain based on current host
  const getCookieDomain = () => {
    if (isLocalhost) {
      console.log("📍 Localhost detected - no domain restriction");
      return undefined; // No domain for localhost
    }
    
    if (isStageServer) {
      // For stage servers, we need to extract the main domain
      const domainParts = host.split('.');
      if (domainParts.length >= 2) {
        // Extract main domain (e.g., srmtechsol.com from nris-stage.srmtechsol.com)
        const mainDomain = domainParts.slice(-2).join('.');
        console.log("🔧 Stage server detected - using main domain:", mainDomain);
        return mainDomain;
      } else {
        console.log("🔧 Stage server detected - using full hostname:", host);
        return host;
      }
    }
    
    if (isLiveServer) {
      console.log("🌐 Live server detected - using .nris.com domain");
      return '.nris.com';
    }
    
    // For any other custom server
    const domainParts = host.split('.');
    if (domainParts.length >= 2) {
      const mainDomain = domainParts.slice(-2).join('.');
      console.log("🎯 Custom server detected - using main domain:", mainDomain);
      return mainDomain;
    }
    
    console.log("⚠️ Unknown server type - using full hostname:", host);
    return host;
  };

  const cookieDomain = getCookieDomain();
  
  console.log("🔧 Server Detection:", {
    host,
    isLocalhost,
    isStageServer,
    isLiveServer,
    cookieDomain,
    domainParts: host ? host.split('.') : []
  });

  // Session management functions
  const checkSession = () => {
    const expiresAt = parseInt(nrisCookies.NrisSessionTime);
    if (isNaN(expiresAt)) return false;
    
    console.log("🍪 Cookie Session Check - Now:",new Date(), "ExpiresAt:",new Date( expiresAt),Date.now() < expiresAt);
    return Date.now() < expiresAt;
  };

  const checkSessionLocalStorage = () => {
    const expiresAt = parseInt(localStorage.getItem("NrisSessionTime"));
    if (isNaN(expiresAt)) return false;
    
    console.log("💾 LocalStorage Session Check - Now:",new Date(), "ExpiresAt:",new Date( expiresAt),Date.now() < expiresAt);
    return Date.now() < expiresAt;
  };

  // Combined session check that works for both cookie and localStorage
  const isSessionValid = () => {
    const cookieValid = checkSession();
    const localStorageValid = checkSessionLocalStorage();
    
    console.log("🔐 Session Validation - Cookie:", cookieValid, "LocalStorage:", localStorageValid);
    
    // Return true if either cookie or localStorage session is valid
    return cookieValid || localStorageValid;
  };

  // Initialize session management
  const initializeSession = () => {
    console.log("🚀 Starting session initialization for server:", host);
    
    try {
      // Check if we have valid cookies and token
      if (nrisCookies && nrisCookies.NrisToken) {
        console.log("✅ Found NrisToken in cookies");
        
        // Check if session is already valid
        if (isSessionValid()) {
          console.log("✅ Session is already valid, extending it");
          
          const expiresAt = new Date().getTime() + SESSION_DURATION;
          const cookieOptions = {
            maxAge: 2 * 24 * 60 * 60,
            path: "/",
            secure: !isLocalhost && window.location.protocol === 'https:', // Only secure for HTTPS
            httpOnly: false,
            sameSite: "lax",
          };
          
          // Add domain only if it's defined
          if (cookieDomain) {
            cookieOptions.domain = cookieDomain;
          }
          
          console.log("🍪 Setting cookies with options:", cookieOptions);
          
          setCookie(null, "NrisSessionTime", expiresAt.toString(), cookieOptions);
          localStorage.setItem("NrisSessionTime", expiresAt.toString());
         
          localStorage.setItem("__nristoken", nrisCookies?.NrisToken);
          localStorage.setItem("__nrisuser", nrisCookies?.NrisUser);
          
          console.log("✅ Session extended successfully for server:", host, "Options:", cookieOptions);
          return true;
        } else {
          console.log("⚠️ Session expired, but token exists - creating new session");
          
          // Create new session with existing token
          const expiresAt = new Date().getTime() + SESSION_DURATION;
          const cookieOptions = {
            maxAge: 2 * 24 * 60 * 60,
            path: "/",
            secure: !isLocalhost && window.location.protocol === 'https:',
            httpOnly: false,
            sameSite: "lax",
          };
          
          if (cookieDomain) {
            cookieOptions.domain = cookieDomain;
          }
          
          console.log("🍪 Creating new session with options:", cookieOptions);
          
          setCookie(null, "NrisSessionTime", expiresAt.toString(), cookieOptions);
          localStorage.setItem("NrisSessionTime", expiresAt.toString());
         
          localStorage.setItem("__nristoken", nrisCookies?.NrisToken);
          localStorage.setItem("__nrisuser", nrisCookies?.NrisUser);
          
          console.log("✅ New session created successfully for server:", host);
          return true;
        }
      } else {
        console.log("❌ No NrisToken found in cookies");
        
        // Check if we have valid localStorage session
        if (isSessionValid()) {
          console.log("✅ Valid session found in localStorage, keeping it");
          return true;
        } else {
          console.log("❌ No valid session found anywhere, clearing all data");
          
          // Clear all session data
          const destroyOptions = { path: '/' };
          if (cookieDomain) {
            destroyOptions.domain = cookieDomain;
          }
          
          console.log("🧹 Clearing cookies with options:", destroyOptions);
          
          destroyCookie(null, 'NrisSessionTime', destroyOptions);
          localStorage.removeItem("__nristoken");
          localStorage.removeItem("__nrisuser");
          localStorage.removeItem("NrisSessionTime");
          
          console.log("🧹 All session data cleared for server:", host);
          return false;
        }
      }
    } catch (error) {
      console.error("💥 Error during session initialization:", error);
      
      // Fallback: clear everything and return false
      try {
        localStorage.removeItem("__nristoken");
        localStorage.removeItem("__nrisuser");
        localStorage.removeItem("NrisSessionTime");
        
        destroyCookie(null, 'NrisSessionTime', { path: '/' });
        destroyCookie(null, 'NrisToken', { path: '/' });
        destroyCookie(null, 'NrisUser', { path: '/' });
      } catch (fallbackError) {
        console.error("💥 Fallback cleanup also failed:", fallbackError);
      }
      
      return false;
    }
  };

  // Initialize session if not in local environment
  // if (!(process.env.REACT_APP_LOCAL && process.env.REACT_APP_LOCAL === "true")) {
  //   initializeSession();
  // } else {
  //   console.log("🏠 Local environment detected, skipping session management");
  // }

  const [token] = useState(localStorage.getItem("__nristoken"));
  const [countryId] = useState(
    nrisCookies && nrisCookies.CountryID ? nrisCookies.CountryID : 1
  );
  console.log(context);

  useRandomToasts();

  // Remove duplicate host declaration
  // const host = window?.location?.hostname;

  const [subdomain] = useState(host && host.split("."));

  // Initialize session in useEffect for proper timing
  useEffect(() => {
    if (!(process.env.REACT_APP_LOCAL && process.env.REACT_APP_LOCAL === "true")) {
      console.log("🚀 Initializing session in useEffect for server:", host);
      initializeSession();
    } else {
      console.log("🏠 Local environment detected, skipping session management");
    }
  }, []); // Run only once on mount

  const getCountryState = () => {
    let country_id;

    if (host) {
      if (
        subdomain[0] !== "www" &&
        subdomain[0] !== "https://www" &&
        subdomain[0] !== "localhost" &&
        subdomain[0] !== "nris-stage" &&
        subdomain[0] !== "carboncompass"
      ) {
        const value = {
          states_name: [subdomain[0].replaceAll("-", " ").toLowerCase()],
        };

        if (
          value.states_name[0] !== "www" ||
          value.states_name[0] !== "localhost" ||
          value.states_name[0] !== ""
        ) {
          try {
            fetchData(
              GET_ALL_STATE_BY_NAME,
              "POST",
              value,
              false,
              false,
              (res) => {
                if (res.status) {
                  country_id = res?.data[0]?.country_id;
                  const state_name = res?.data[0]?.name;
                  const state_id = res?.data[0]?.id;

                  fetchData(GET_ALL_COUNTRY, "GET", "", false, false, (res) => {
                    if (res.status) {
                      setContext((prevValue) => ({
                        ...prevValue,
                        countryId: country_id,
                        countryList: res?.data,
                        stateView: true,
                        stateName: state_name,
                        stateId: state_id,
                      }));

                      fetchData(
                        GET_ALL_STATE_BY_COUNTY_ID,
                        "POST",
                        { country_id: country_id },
                        false,
                        false,
                        (res) => {
                          if (res.status) {
                            setContext((prevValue) => ({
                              ...prevValue,
                              stateList: res?.data,
                            }));
                          } else {
                            console.log(res);
                          }
                        }
                      );
                    } else {
                      console.log(res);
                    }
                  });
                } else {
                  console.log(res);
                }
              }
            );
          } catch (error) {
            console.log("error", error);
          }
        }
      } else {
        fetchData(GET_ALL_COUNTRY, "GET", "", false, false, (res) => {
          if (res.status) {
            setContext((prevValue) => ({
              ...prevValue,
              countryId: countryId ? countryId : res?.data[0]?.id,
              countryList: res?.data,
              stateView: false,
              stateName: "",
            }));

            let value = {
              country_id: countryId ? countryId : res?.data[0]?.id,
            };

            fetchData(
              GET_ALL_STATE_BY_COUNTY_ID,
              "POST",
              value,
              false,
              false,
              (res) => {
                if (res.status) {
                  setContext((prevValue) => ({
                    ...prevValue,
                    stateList: res?.data,
                    stateId: res?.data[0]?.id,
                  }));
                } else {
                  console.log(res);
                }
              }
            );
          } else {
            console.log(res);
          }
        });
      }
    }
  };

  useEffect(() => {
    if (token) {
      setContext((prevValue) => ({
        ...prevValue,
        user: JSON.parse(localStorage.getItem("__nrisuser")),
        userToken: token,
      }));
    }
    getCountryState();
  }, []);

  useEffect(() => {
    window.$(document).ready(function () {
      window.$(window).scroll(function () {
        if (window.$(this).scrollTop() > 50) {
          window.$(".header").addClass("bg-white");
        } else {
          window.$(".header").removeClass("bg-white");
        }
      });
    });
  }, []);

  const logout = () => {
    console.log("🚪 Starting logout for server:", host);

    try {
      // Clear cookies with domain if available
      if (cookieDomain) {
        console.log("🗑️ Clearing cookies with domain:", cookieDomain);
        
        const destroyOptions = {
          path: '/',
          domain: cookieDomain,
        };
        
        destroyCookie(null, 'NrisSessionTime', destroyOptions);
        destroyCookie(null, 'NrisToken', destroyOptions);
        destroyCookie(null, 'NrisUser', destroyOptions);
      }
      
      // Also clear cookies without domain as fallback
      console.log("🗑️ Clearing cookies without domain as fallback");
      destroyCookie(null, "NrisSessionTime", { path: "/" });
      destroyCookie(null, "NrisToken", { path: "/" });
      destroyCookie(null, "NrisUser", { path: "/" });
      
      // Clear localStorage
      localStorage.removeItem("__nristoken");
      localStorage.removeItem("__nrisuser");
      localStorage.removeItem("NrisSessionTime");
      
      // Update context
      setContext((prevValue) => ({
        ...prevValue,
        user: "",
        userToken: "",
      }));
      
      console.log("✅ Logout completed successfully for server:", host);
      
    } catch (error) {
      console.error("💥 Error during logout:", error);
      
      // Fallback: force clear everything
      try {
        localStorage.removeItem("__nristoken");
        localStorage.removeItem("__nrisuser");
        localStorage.removeItem("NrisSessionTime");
        
        setContext((prevValue) => ({
          ...prevValue,
          user: "",
          userToken: "",
        }));
        
        console.log("🔄 Fallback logout completed");
      } catch (fallbackError) {
        console.error("💥 Fallback logout also failed:", fallbackError);
      }
    }
  };

// const resetTimer = useCallback(() => {
//   const SESSION_DURATION = 1 * 60 * 1000; // 1 minute

//   const expiresAt = Date.now() + SESSION_DURATION;
//   setCookie(null, "NrisSessionTime", expiresAt.toString(), {
//     maxAge: SESSION_DURATION / 1000,
//     path: "/",
//     secure: true,
//     sameSite: "lax",
//   });
// }, []);

//   useEffect(() => {
//     if (!localStorage.getItem("__nristoken")) return;

//     const checkInactivity = () => {
//       if (document?.hidden){
//         return
//       }
      
//       if (!checkSession() && nrisCookies.NrisToken) {

//         logout()
//         window.$("#inactiveSessionModal").modal("show");
//       }
//     };

//     resetTimer();

//     const interval = setInterval(checkInactivity, 60 * 1000);
//     const events = ["mousemove", "keydown", "click"];

//     events.forEach((event) => window.addEventListener(event, resetTimer));

//     return () => {
//       clearInterval(interval);
//       events.forEach((event) => window.removeEventListener(event, resetTimer));
//     };
//   }, [resetTimer]);

const resetTimer = () => {
  try {
    console.log("⏰ Resetting session timer for server:", host);
    
    const expiresAt = Date.now() + SESSION_DURATION;
    const cookieOptions = {
      maxAge: 2 * 24 * 60 * 60,
      path: "/",
      secure: !isLocalhost && window.location.protocol === 'https:', // Only secure for HTTPS
      httpOnly: false,
      sameSite: "lax",
    };
    
    // Add domain only if it's defined
    if (cookieDomain) {
      cookieOptions.domain = cookieDomain;
    }

    console.log("🍪 Resetting timer with cookie options:", cookieOptions);

    setCookie(null, "NrisSessionTime", expiresAt.toString(), cookieOptions);
    localStorage.setItem("NrisSessionTime", expiresAt.toString());
    
    console.log("✅ Session timer reset successfully for server:", host, "Expires at:", new Date(expiresAt));
    
  } catch (error) {
    console.error("💥 Error resetting session timer:", error);
    
    // Fallback: try without domain
    try {
      console.log("🔄 Attempting fallback timer reset without domain");
      const fallbackOptions = {
        maxAge: 2 * 24 * 60 * 60,
        path: "/",
        secure: false,
        httpOnly: false,
        sameSite: "lax",
      };
      
      setCookie(null, "NrisSessionTime", (Date.now() + SESSION_DURATION).toString(), fallbackOptions);
      localStorage.setItem("NrisSessionTime", (Date.now() + SESSION_DURATION).toString());
      
      console.log("✅ Fallback timer reset completed");
    } catch (fallbackError) {
      console.error("💥 Fallback timer reset also failed:", fallbackError);
    }
  }
};

  useEffect(() => {
    console.log("🔄 Starting session monitoring for server:", host);
    console.log("🌐 Current domain configuration:", { host, cookieDomain, protocol: window.location.protocol });
    
    const interval = setInterval(() => {
      try {
        console.log("🔍 Session check for server:", host, "Time:", new Date().toISOString());
        console.log("🍪 Current cookies:", nrisCookies);
        console.log("💾 Current localStorage:", {
          token: localStorage.getItem("__nristoken") ? "EXISTS" : "NOT_FOUND",
          user: localStorage.getItem("__nrisuser") ? "EXISTS" : "NOT_FOUND",
          sessionTime: localStorage.getItem("NrisSessionTime")
        });
        
        if (document?.hidden){
          console.log("👁️ Document is hidden, skipping session check");
          return
        }
        
        // Check if user has token
        const hasToken = localStorage.getItem("__nristoken");
        if (!hasToken) {
          console.log("🔑 No token found in localStorage, skipping session check");
          return
        }
        
        // Check if session is still valid
        const sessionValid = isSessionValid();
        console.log("🔐 Current session status:", sessionValid);
        
        if (!sessionValid) {
          console.log("⏰ Session expired, logging out user");
          logout();
          window.$("#inactiveSessionModal").modal("show");
        } else {
          console.log("✅ Session is valid, extending timer");
          resetTimer()
        }
    
      } catch (error) {
        console.error("💥 Error during session check:", error);
        console.log("🔄 Continuing session monitoring despite error");
      }
  
    }, 30 * 1000); // Check every 30 seconds instead of 5 seconds
  
    // Cleanup on unmount
    return () => {
      console.log("🛑 Stopping session monitoring for server:", host);
      clearInterval(interval);
    };
  }, [host, cookieDomain]); // Add both host and cookieDomain as dependencies
  

  useEffect(() => {
    const title = context?.stateName?.trim()
      ? `${context.stateName.trim()} - NRIS`
      : "NRIS";
    document.title = title;
  }, [context?.stateName]);
  

  return (
    <>
      {context && context?.countryId && context?.stateId && (
        <Context.Provider value={[context, setContext]}>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/" element={<CountryLayout />}>
                <Route index element={<Home />} />
                <Route path="login" element={<Home />} />
                <Route element={<AdsWrapper />}>
                  <Route path="verify-email/:token" element={<VerifyEmail />} />
                  <Route path="about-us" element={<AboutUs />} />
                  <Route path="privacy" element={<Privacy />} />
                  <Route path="disclaimer" element={<Disclaimer />} />
                  <Route path="advertise-with-us" element={<Advertise />} />
                  <Route
                    path="terms-and-conditions"
                    element={<TermsCondition />}
                  />
                  <Route path="contact-us" element={<ContactUs />} />
                  <Route path="forums">
                    <Route path="" element={<Forum />} />
                    <Route path=":forum_id" element={<ForumDetails />} />
                  </Route>
                  <Route path="autos">
                    <Route path="" element={<Autos />} />
                    <Route path=":auto_id" element={<AutosDetails />} />
                    <Route
                      path="create-ads/:ads_id/:ads_type"
                      element={<CreateAds />}
                    />
                  </Route>
                  <Route path="business">
                    <Route path=":business_id" element={<BusinessListing />} />
                    <Route
                      path="details/:business_id"
                      element={<BusinessDetails />}
                    />
                  </Route>
                  <Route path="classifieds">
                    <Route path="" element={<Classified />} />
                    <Route path=":ads_id" element={<FreeAds />} />
                    <Route path="details/:ads_id" element={<FreeAdsDetails />} />
                    <Route
                      path="create-ads/:ads_id/:ads_type"
                      element={<CreateAds />}
                    />
                  </Route>
                  <Route path="carpool">
                    <Route path=":carpool_id" element={<Carpool />} />
                    <Route
                      path="details/:carpool_id"
                      element={<CarpoolDetails />}
                    />
                    <Route
                      path="create/:carpool_id"
                      element={<CreateCarpool />}
                    />
                  </Route>
                  <Route path="nri-talks">
                    <Route path="" element={<NrisTalk />} />
                    <Route path=":nris_talk_id" element={<NrisTalkDetails />} />
                  </Route>
                  <Route path="student-talks">
                    <Route path="" element={<StudentTalk />} />
                    <Route
                      path=":student_talk_id"
                      element={<StudentTalkDetails />}
                    />
                  </Route>
                  <Route path="movie-reviews">
                    <Route path="" element={<MovieReviews />} />
                    <Route
                      path=":movie_review_id"
                      element={<MovieReviewsDetails />}
                    />
                  </Route>
                  <Route path="events">
                    <Route path="" element={<Event />} />
                    <Route path=":event_id" element={<EventDetails />} />
                  </Route>
                  <Route path="traning-placemant">
                    <Route path="" element={<Traning />} />
                    <Route path=":traning_id" element={<TraningDetails />} />
                  </Route>
                  <Route path="news-articles">
                    <Route path="" element={<News />} />
                    <Route path=":news_id" element={<NewsDetails />} />
                  </Route>
                  <Route path="blogs">
                    <Route path="" element={<Blog />} />
                    <Route path=":blog_id" element={<BlogDetails />} />
                  </Route>
                  <Route path="movies">
                    <Route path="" element={<MovieAll />} />
                    <Route path=":lang_id" element={<Movie />} />
                  </Route>
                  <Route path="desi-page">
                    <Route path="" element={<DesiPage />} />
                    <Route path=":desi_page_id" element={<DesiPageDetails />} />
                  </Route>
                  <Route path="real-estate">
                    <Route path="" element={<RealEstate />} />
                    <Route
                      path=":real_estate_id"
                      element={<RealEstateDetails />}
                    />
                    <Route
                      path="create-ads/:ads_id/:ads_type"
                      element={<CreateAds />}
                    />
                  </Route>
                  <Route path="search-results">
                    <Route path="" element={<SearchResults />} />
                  </Route>

                  <Route
                    path="change-forgot-password/:cp_token"
                    element={<ChangeForgotPassword />}
                  />
                  {/* {context?.userToken && ( */}
                    <Route path="profile" element={<MyProfile />} />
                  {/* )} */}
                  {context && context.id ? (
                    <></>
                  ) : (
                    <Route path="/*" element={<NotFound />} />
                  )}
                </Route>
              </Route>
            </Routes>
          </Suspense>
        </Context.Provider>
      )}
    </>
  );
};

export default Routing;
